module.exports = __webpack_public_path__ + "img/1440.dc19d79e.jpg";